import styled from 'styled-components';
import { Button as ButtonComponent } from 'components/Button';

export const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 24px;
  border: 1px solid var(--v3-black-2);
  background: var(--v3-black-0);
  z-index: 50;
  display: flex;
  width: 100%;
  height: 100%;
  padding: 32px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 32px;
  flex-shrink: 0;
`;

export const TextIconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  img {
    margin: 0 auto;
    width: 100px;
  }
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`;

export const TextHeading = styled.div`
  display: flex;
  width: 364px;
  flex-direction: column;
  color: var(--v3-text-color);
  text-align: center;
  font-size: 2rem;
  font-weight: 700;
  line-height: 36px;
  letter-spacing: -0.32px;
`;

export const TextDescription = styled.div`
  color: var(--v3-black-45);
  text-align: center;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.16px;
`;

export const Button = styled(ButtonComponent)`
  &&& {
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    padding: 0 24px;
    margin: 12px 0;
    display: flex;
    justify-content: center;
  }
`;
